import { motion } from "framer-motion";
import { ArrowUpRight, Utensils } from "lucide-react";

const FOOD_IMG = "/hole8-food.jpg";

const FEATURES = [
  {
    icon: Utensils,
    title: "Freshly Prepared Food",
    desc: "Enjoy a selection of freshly prepared meals, snacks and refreshments during your round.",
  },
  {
    icon: Utensils,
    title: "Order for Hole 8",
    desc: "Place your order before reaching the 8th hole.",
  },
];

export default function OnCourseTech() {
  return (
    <section
      id="food-drinks"
      data-testid="food-drinks-section"
      className="hidden bg-white py-24 md:py-32 lg:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="max-w-4xl mx-auto text-center"
        >
          <span className="section-eyebrow">
            05 · Food & Beverage Service
          </span>

          <h2 className="font-serif-luxury text-4xl md:text-5xl lg:text-6xl text-[#0F4C3A] mt-5 leading-[1.05] tracking-tight">
            On-Course Food
            <span className="block italic text-gold-metallic">
              & Refreshments
            </span>
          </h2>

          <p className="text-[#4A4A4A] mt-6 max-w-2xl mx-auto leading-relaxed">
            Enhance your round with freshly prepared food and refreshments.
            Browse the menu and place your order before reaching the 8th hole.
          </p>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-8">
            {FEATURES.map((f) => (
              <div
                key={f.title}
                className="bg-[#FAFAFA] border border-[#CBA153]/30 p-8 text-left"
              >
                <f.icon
                  size={24}
                  strokeWidth={1.4}
                  className="text-[#0F4C3A] mb-4"
                />

                <h4 className="font-serif-luxury text-xl text-[#0F4C3A]">
                  {f.title}
                </h4>

                <p className="text-sm text-[#4A4A4A] mt-2 leading-relaxed">
                  {f.desc}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-12 image-frame border border-[#CBA153]/30 overflow-hidden">
            <img
              src={FOOD_IMG}
              alt="Food and refreshments available at Hole 8"
              className="w-full h-[350px] md:h-[450px] object-cover"
            />
          </div>

          <div className="mt-12">
            <a
              href="https://gowergolfcourse-ltd.square.site/"
              target="_blank"
              rel="noopener noreferrer"
              className="ggc-btn-primary group"
            >
              Order Food & Drinks
              <ArrowUpRight
                size={16}
                strokeWidth={1.5}
                className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
